export default "/images/vendor/flag-icon-css/flags/1x1/ai.svg?546a12e334b3f4d8967c7cd65178f7f0";